import { usePhotographer } from 'views/photographer/context'
import useRouter from 'hooks/use-router'
import { useEffect } from 'react'
import useMainClass from 'hooks/use-main-cass'
import textServices from 'services/text-services'
import { Photographer } from 'views/photographer/context/types'
import { DivTitleSelect, TitleSelect, CardSelect, CardSelectTitle, CardSelectDescription, CardSelectImage } from './custom.style'

const Container = ({ children, title }: { children: React.ReactNode, title?: string }) => (
  <section className="flex flex-col gap-6">
    <div className='w-screen max-w-7xl z-1 flex flex-col gap-6 flex-1 items-center'>
      <DivTitleSelect className="flex items-center px-10 w-screen py-5">
        <TitleSelect className="flex-grow max-w-full">
          {title || textServices.findByText('photographer/select/title', { es: 'SELECCIONE UN RALLY', en: 'SELECT A RALLY' })}
        </TitleSelect>
      </DivTitleSelect>
      {children}
    </div>
  </section>
)

function Select() {
  const [{ rallies, current }, { selectRally }] = usePhotographer()
  const { push } = useRouter()
  useMainClass('album__multimedia__profile')

  useEffect(() => {
    // If there is only one rally or current is already set, go straight to start
    if (current) {
      return push('/photographer/start')
    }
    if (rallies?.length === 1) {
      selectRally(rallies[0])
      return push('/photographer/start')
    }
    if (rallies && rallies.length === 0) {
      return push('/photographer/winners')
    }
  }, [rallies, current])

  const handleSelect = (rally: Photographer) => {
    selectRally(rally)
    push('/photographer/start')
  }

  const formatDate = (dateStr: string) => {
    if (!dateStr) return ''
    try {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' })
    } catch {
      return dateStr
    }
  }

  if (!rallies || rallies.length <= 1) return null

  return (
    <Container>
      <article className='w-full flex flex-col gap-4 px-6 pb-8'>
        <p className='text-center text-sm opacity-70'>
          {textServices.findByText('photographer/select/description', {
            es: `Hay ${rallies.length} rallies activos. Seleccione en cuál desea participar.`,
            en: `There are ${rallies.length} active rallies. Select which one you want to participate in.`
          })}
        </p>
        <div className="flex flex-col gap-4 mt-2">
          {rallies.map((rally) => (
            <CardSelect
              key={rally.id}
              className="w-full flex flex-col"
              onClick={() => handleSelect(rally)}
            >
              {rally?.multimedias?.[0]?.imageUrl && (
                <CardSelectImage
                  src={rally.multimedias[0].imageUrl}
                  alt={rally.name}
                />
              )}
              <div className="flex flex-col gap-2 p-4">
                <CardSelectTitle>{rally.name}</CardSelectTitle>
                <CardSelectDescription>
                  {formatDate(rally.validFrom)} — {formatDate(rally.validTo)}
                </CardSelectDescription>
                {rally.buttonText && (
                  <div className="mt-2 text-center py-2 px-4 rounded-lg bg-current bg-opacity-10 text-sm font-bold uppercase">
                    {rally.buttonText}
                  </div>
                )}
              </div>
            </CardSelect>
          ))}
        </div>
      </article>
    </Container>
  )
}

export default Select
